import { render, staticRenderFns } from "./list.vue?vue&type=template&id=dbec2bf0&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=dbec2bf0&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=dbec2bf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbec2bf0",
  null
  
)

export default component.exports